import React, { useEffect, useState } from "react";
import Header from "../../layouts/Header";
import Footer from "../../layouts/Footer";
import { Link } from "react-router-dom";
import { Button, Card, Col, Nav, OverlayTrigger, Form, Row, Tooltip } from "react-bootstrap";
export default function AdvertiserProduct() {

  const currentSkin = (localStorage.getItem('skin-mode')) ? 'dark' : '';
  const [skin, setSkin] = useState(currentSkin);

  const switchSkin = (skin) => {
    if (skin === 'dark') {
      const btnWhite = document.getElementsByClassName('btn-white');

      for (const btn of btnWhite) {
        btn.classList.add('btn-outline-primary');
        btn.classList.remove('btn-white');
      }
    } else {
      const btnOutlinePrimary = document.getElementsByClassName('btn-outline-primary');

      for (const btn of btnOutlinePrimary) {
        btn.classList.remove('btn-outline-primary');
        btn.classList.add('btn-white');
      }
    }
  };

  switchSkin(skin);

  useEffect(() => {
    switchSkin(skin);
  }, [skin]);

  return (
    <React.Fragment>
      <Header onSkin={setSkin} />
      <div className="main main-app p-3 p-lg-4">

        <div className="d-flex align-items-center justify-content-between">
          <div>
            <ol className="breadcrumb fs-sm mb-1">
              <li className="breadcrumb-item"><Link href="#">ADV Home</Link></li>
              <li className="breadcrumb-item">ABC Bank</li>
              <li className="breadcrumb-item active" aria-current="page">Product Details</li>
            </ol>
            <h4 className="main-title mb-0">Product Details</h4>
          </div>

          <Nav as="nav" className="nav-icon nav-icon-lg">
            <OverlayTrigger overlay={<Tooltip>Share</Tooltip>}>
              <Nav.Link href=""><i className="ri-share-line"></i></Nav.Link>
            </OverlayTrigger>
            <OverlayTrigger overlay={<Tooltip>Print</Tooltip>}>
              <Nav.Link href=""><i className="ri-printer-line"></i></Nav.Link>
            </OverlayTrigger>
            <OverlayTrigger overlay={<Tooltip>Report</Tooltip>}>
              <Nav.Link href=""><i className="ri-bar-chart-2-line"></i></Nav.Link>
            </OverlayTrigger>
          </Nav>
        </div>

        <Row className="g-3 justify-content-center mt-3">
  
          <Col md="12">
            <Card className="card-settings">
              <Card.Header>
                <Card.Title>Product Information</Card.Title>
                <Card.Text>This information is used globally for your campaign.</Card.Text>
              </Card.Header>
              <Card.Body className="p-0">
                <div className="setting-item">
                  <Row className="g-2 align-items-center">
                    <Col md="2">
                      <h6>Product Name</h6>
                      <p>Required</p>
                    </Col>
                    <Col md>
                      <Form.Control type="text" placeholder="Enter name" />
                    </Col>
                  </Row>
                </div>
                <div className="setting-item">
                  <Row className="g-2">
                    <Col md="2">
                      <h6>Main Landing Page</h6>
                      <p>Required</p>
                    </Col>
                    <Col md>
                      <Form.Control type="text" placeholder="http(s)://" />
                    </Col>
                  </Row>
                </div>
                <div className="setting-item">
                  <Row className="g-2 align-items-center">
                    <Col md="2">
                      <h6>Product Logo</h6>
                      <p>Required<br/>150x150px, JPG/PNG</p>
                    </Col>
                    <Col md>
                      <Button variant="" className="btn-white">Upload Logo</Button>
                    </Col>
                  </Row>
                </div>
                <div className="setting-item">
                  <Row className="g-2 align-items-center">
                    <Col md="2">
                      <h6>Screenshots</h6>
                      <p>1 min, add up to 4<br/>1600x900px, JPG/PNG</p>
                    </Col>
                    <Col md>
                      <Button variant="" className="btn-white">Upload Screenshots</Button>
                    </Col>
                  </Row>
                </div>
                <div className="setting-item">
                  <Row className="g-2 align-items-center">
                    <Col md="2">
                      <h6>Billing</h6>
                      <p>Required</p>
                    </Col>
                    <Col md>
                      <Form.Check type="checkbox" checked label="Monthly Net 30 - you will be billed at the end of each billing period and are required to pay via bank transfer within 30 days." className="mt-3" />
                      <Form.Check type="checkbox" label="Credit Card [option coming soon]" disabled="disabled" className="mt-1" />
                    </Col>
                  </Row>
                </div>
              </Card.Body>
            </Card>
          </Col>

        </Row>

        <Footer />
      </div>
    </React.Fragment>
  )
}